export class LocationImport {
  id!: string;
  locationId!: string;
  locationName!: string;
  latitude!: number;
  longitude!: number;
  address!: string;
  postalCode!: string;
  city!: string;
  country!: string;
  stopTime!: string;
  openingHours!: string;
  productName!: string;
  productId!: string;
  activityName!: string;
  serviceStopTime!: string;
  serviceFromTime!: string;
  serviceToTime!: string;
  pickupCapacityType1!: number;
  pickupCapacityType2!: number;
  pickupCapacityType3!: number;
  deliveryCapacityType1!: number;
  deliveryCapacityType2!: number;
  deliveryCapacityType3!: number;
}
